export enum BidIntentButtonTitle {
    VIEW_ONLY_INTNET_TITLE = 'View Only',
    IM_OUT_INTENT_TITLE = "I'm Out",
    MAY_BID_INTENT_TITLE = 'May Bid'
}
